<template>
  <!-- 消息通知 start -->
  <el-popover
    placement="bottom"
    popper-class="popperPadding"
    trigger="click"
    width="500"
  >
    <el-badge slot="reference" :hidden="badgeNumber === 0"
              :value="badgeNumber"
              class="base-margin__right-10">
      <i class="el-icon-bell base-cursor__pointer badge-size"></i>
    </el-badge>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>{{ $t('messageCenter.notification') }}</span>
        <el-button v-if="describeNotifyList.length === 0" class="no-message base-color__black" type="text">
          {{ $t('messageCenter.noMessage') }}
        </el-button>
        <el-button v-if="describeNotifyList.length !== 0" class="no-message" type="text" @click="allRead">
          {{ $t('messageCenter.markAllAsRead') }}
        </el-button>
        <el-button class="no-message base-margin__right-10"
                   type="text"
                   @click="openMessageInfo">
          {{ $t('messageCenter.viewAll') }}
        </el-button>
      </div>
      <div
        v-for="(item, index) in describeNotifyList"
        :key="item.id" :class="item.activeId === '1' ? 'msg-read' : '' "
      >
        <div
          class="base-cursor__pointer"
          @click="clickRead(index, item)"
        >
          <span
            :title="item.title"
            class="content_width_190 base__font-weight_Bold base__text-not-wrap-ellipsis"
          >
            {{ item.title }}
          </span>
          <span>{{ item.createTime }}</span>
        </div>
        <div class="card_content">{{ item.content }}</div>
        <el-divider></el-divider>
      </div>
    </el-card>
  </el-popover>
  <!-- 消息通知 end -->
</template>

<script>
import {getRequest, postRequest} from '@/common/libs/request';

export default {
  name: 'messageCenter',
  data() {
    return {
      // 通知列表
      describeNotifyList: [],
      badgeNumber: 0,
    };
  },
  async mounted() {
    await this.getDescribeNotifyList();
  },

  methods: {
    /**
     * 获取消息列表
     **/
    getDescribeNotifyList() {
      getRequest('/api/eda/common/notify/describeNotifyList?notifyStatusId=0&offset=0&limit=10').then((res) => {
        this.describeNotifyList = res.list || [];
        this.badgeNumber = res.list.length || 0;
      });
    },

    /**
     * 查看全部信息
     **/
    openMessageInfo() {
      this.$router.push('/messageInfo');
    },

    /**
     * 全部已读
     * **/
    allRead() {
      postRequest('/api/eda/common/notify/changeNotifyStatus', {notifyStatusId: -1}).then(() => {
        this.$message.success(this.$t('messageCenter.markAllAsReadSuccess'));
        this.getDescribeNotifyList();
      });
    },
    /**
     * 点击读取消息
     * @param index 所对应item的下标
     * @param item 当前选中的消息信息
     **/
    clickRead(index, item) {
      postRequest('/api/eda/common/notify/changeNotifyStatus', {notifyStatusId: item.id});
      this.getDescribeNotifyList();
    },
  },
};
</script>

<style lang="scss" scoped>
// icon图标的大小
.badge-size {
  font-size: 20px;
}

// 取消popover组件的padding
.popperPadding {
  padding: 0;
}

// 修改card的样式
.box-card {
  width: 100%;
  border: none;
  max-height: 700px;
  overflow: auto;
}

.clearfix {

}

// 消息已读的展示颜色
.msg-read {
  color: #D0D0D0;
}

// card主体内容的间距以及文字大小
.card_content {
  margin-top: 8px;
  font-size: 13px;
}

// 暂无消息 全部已读的css
.no-message {
  float: right;
  padding: 3px 0;
}

.content_width_190 {
  width: 260px;
}
</style>
